/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PatchedEvidenceSerialiser
 */
export interface PatchedEvidenceSerialiser {
  /**
   *
   * @type {number}
   * @memberof PatchedEvidenceSerialiser
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedEvidenceSerialiser
   */
  title?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedEvidenceSerialiser
   */
  artefacts?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof PatchedEvidenceSerialiser
   */
  description?: string | null;
}

/**
 * Check if a given object implements the PatchedEvidenceSerialiser interface.
 */
export function instanceOfPatchedEvidenceSerialiser(value: object): value is PatchedEvidenceSerialiser {
  return true;
}

export function PatchedEvidenceSerialiserFromJSON(json: any): PatchedEvidenceSerialiser {
  return PatchedEvidenceSerialiserFromJSONTyped(json, false);
}

export function PatchedEvidenceSerialiserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedEvidenceSerialiser {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    title: json['title'] == null ? undefined : json['title'],
    artefacts: json['artefacts'] == null ? undefined : json['artefacts'],
    description: json['description'] == null ? undefined : json['description'],
  };
}

export function PatchedEvidenceSerialiserToJSON(value?: Omit<PatchedEvidenceSerialiser, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    title: value['title'],
    artefacts: value['artefacts'],
    description: value['description'],
  };
}
